// eslint-disable-next-line import/prefer-default-export
export const LISTE_JOURNAL_ECRITURE = {
  title: 'Journal',
  racine: 'Accueil',
  montantTotalPiece: 'Montant total des pièces :',
  actions: {
    add: 'Ajouter un exercice comptable',
    export: 'Exporter au format excel',
    search: 'Rechercher',
    filter: 'Filtre',
    createLot: 'Créer un lot',
    associeLot: 'Associer à un lot',
    generationEcriture: 'Générer les écritures',
    applique: 'Appliquer',
    libellePopupCreateLot: 'Créer un lot comptable',
    libellePopupAssocieLot: 'Associer à un lot',
    labelPopupLot: 'Libellé du lot',
    boutonPopupClose: 'Annuler',
    boutonPopupCreate: 'Créer',
    msgSuccess: 'créé avec succès',
    associeSuccess: 'Associer au lot avec succès',
    noResult: 'Aucun lot correspondant',
  },
  tab: {
    date: 'Date',
    libelle: 'Libellé',
    journal: 'Journal',
    compte: 'Compte',
    debit: 'Débit',
    credit: 'Crédit',
    debut: 'Début',
    fin: 'Fin',
    lot: 'Lot',
    etatLot: 'Etat du Lot',
    etat: 'Etat',
    montant: 'Montant',
    isValid: 'Etat',
    referencePiece: 'Référence pièce',
    typeEcriture: 'Type d\'écriture',
  },
  etat: {
    valide: 'Valide',
    nonValide: 'Non validé',
  },
  lot: {
    etat: {
      aucun: 'Aucun',
      actif: 'A transmettre',
      transmis: 'Transmis',
    },
  },
  typeEcriture: {
    vente: 'Vente',
    reglement: 'Règlement',
    achat: 'Achat',
    paiement: 'Paiement',
    od: 'OD',
  },
  filtre: {
    lot: 'Lot',
    etat: 'Etat de l\'écriture',
    exercice: 'Exercice',
    periode: 'Période',
    au: 'au',
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    typeEcriture: 'Type d\'écriture',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    error: {
      dateFin: 'La date de fin doit être supérieure à la date de début',
    },
  },
  msgError: {
    lotAssocieEtatTransmi: 'Le lot associé a une des ecritures est déjà à l\'état transmis',
    lotComptaEtatTransmi: 'Le lot comptable est à l\'état transmis',
    libelleObligatoire: 'Le champ Libelle est obligatoire.',
    lengthFieldLibelle: 'Le champ Libelle doit être une chaîne d\'une longueur minimale de 1 et d\'une longueur maximale de 255.',
    invalidAccountingWriting: 'L\'écriture comptable {param1} ({param2}) refs : {param3} n\'est pas valide.',
    ecritureIsInLot: 'L\'écriture comptable ne peut pas être supprimée car elle est présente dans un lot comptable.',
  },
  popupSupprimer: {
    title: 'Êtes-vous sûr de vouloir supprimer cette écriture comptable ?',
  },
  libelleLotAjout: 'Lot du ',
  generationEcriture: {
    title: 'Au moins une écriture est déjà dans un lot, une nouvelle écriture sera générée. Attention aux doublons dans le logiciel de comptabilité',
    success: 'Les écritures ont été générées avec succès',
  },
};

export const POPUP_ECRITURES = {
  title: 'Ecriture comptable',
};
